import { S as SocialLoginResponseStatus } from '../../chuck/SocialLoginResponseStatus-BP1cpX8W.js';
import { g as getDefaultExportFromCjs } from '../../chuck/_commonjsHelpers-B85MJLTf.js';
import { r as requireScriptLoader } from '../../chuck/scriptLoader-C7O-_j6M.js';

function asyncGeneratorStep$1(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator$1(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep$1(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep$1(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _ts_generator$1(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var AppleSdkLogin = /*#__PURE__*/ _async_to_generator$1(function(config) {
    var _AppleID, result, authorization, user, _user_name_firstName, _user_name_lastName, error, errorText;
    return _ts_generator$1(this, function(_state) {
        switch(_state.label){
            case 0:
                _state.trys.push([
                    0,
                    2,
                    ,
                    3
                ]);
                if (!((_AppleID = AppleID) == null ? void 0 : _AppleID.auth)) {
                    return [
                        2,
                        {
                            status: SocialLoginResponseStatus.LoadError
                        }
                    ];
                }
                return [
                    4,
                    AppleID.auth.signIn()
                ];
            case 1:
                result = _state.sent();
                authorization = result.authorization, user = result.user;
                if (!!authorization.code) {
                    return [
                        2,
                        {
                            code: authorization.code,
                            status: SocialLoginResponseStatus.Success,
                            context: {
                                firstName: (_user_name_firstName = user == null ? void 0 : user.name.firstName) != null ? _user_name_firstName : '',
                                lastName: (_user_name_lastName = user == null ? void 0 : user.name.lastName) != null ? _user_name_lastName : ''
                            }
                        }
                    ];
                }
                return [
                    2,
                    {
                        status: SocialLoginResponseStatus.Error,
                        error: "Apple doesn't return auth_code"
                    }
                ];
            case 2:
                error = _state.sent();
                errorText = JSON.stringify(error);
                if (errorText.includes('popup_closed_by_user')) {
                    return [
                        2,
                        {
                            status: SocialLoginResponseStatus.UserCancelled,
                            error: errorText
                        }
                    ];
                }
                return [
                    2,
                    {
                        status: SocialLoginResponseStatus.Error,
                        error: "" + errorText
                    }
                ];
            case 3:
                return [
                    2
                ];
        }
    });
});

var loadAppleSdk$1 = {};

var hasRequiredLoadAppleSdk;
function requireLoadAppleSdk() {
    if (hasRequiredLoadAppleSdk) return loadAppleSdk$1;
    hasRequiredLoadAppleSdk = 1;
    var __awaiter = loadAppleSdk$1 && loadAppleSdk$1.__awaiter || function(thisArg, _arguments, P, generator) {
        return new (P || (P = Promise))(function(resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator["throw"](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done ? resolve(result.value) : new P(function(resolve) {
                    resolve(result.value);
                }).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    };
    var __generator = loadAppleSdk$1 && loadAppleSdk$1.__generator || function(thisArg, body) {
        var _ = {
            label: 0,
            sent: function sent() {
                if (t[0] & 1) throw t[1];
                return t[1];
            },
            trys: [],
            ops: []
        }, f, y, t, g;
        return g = {
            next: verb(0),
            "throw": verb(1),
            "return": verb(2)
        }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
            return this;
        }), g;
        function verb(n) {
            return function(v) {
                return step([
                    n,
                    v
                ]);
            };
        }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while(_)try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [
                    op[0] & 2,
                    t.value
                ];
                switch(op[0]){
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return {
                            value: op[1],
                            done: false
                        };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [
                            0
                        ];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2]) _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            } catch (e) {
                op = [
                    6,
                    e
                ];
                y = 0;
            } finally{
                f = t = 0;
            }
            if (op[0] & 5) throw op[1];
            return {
                value: op[0] ? op[1] : void 0,
                done: true
            };
        }
    };
    var _this = loadAppleSdk$1;
    Object.defineProperty(loadAppleSdk$1, "__esModule", {
        value: true
    });
    var scriptLoader_1 = requireScriptLoader();
    var SCRIPT_ID = 'apple-jssdk';
    var injectScript = function injectScript(culture) {
        return scriptLoader_1.ScriptLoader.LoadScriptAsync({
            src: "https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/" + culture + "/appleid.auth.js",
            id: SCRIPT_ID
        });
    };
    var initAppleSdk = function initAppleSdk(params, culture) {
        if (culture === void 0) {
            culture = 'en_US';
        }
        return __awaiter(_this, void 0, void 0, function() {
            var error_1;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (window.AppleID) {
                            return [
                                2 /*return*/ ,
                                window.AppleID
                            ];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            injectScript(culture)
                        ];
                    case 2:
                        _a.sent();
                        window.AppleID && window.AppleID.auth && window.AppleID.auth.init(params);
                        return [
                            2 /*return*/ ,
                            window.AppleID
                        ];
                    case 3:
                        error_1 = _a.sent();
                        throw new Error(error_1);
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    loadAppleSdk$1.default = initAppleSdk;
    
    return loadAppleSdk$1;
}

var loadAppleSdkExports = requireLoadAppleSdk();
var loadAppleSdk = /*@__PURE__*/getDefaultExportFromCjs(loadAppleSdkExports);

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var AppleSdkLoader = /*#__PURE__*/ _async_to_generator(function(config) {
    var params, appleId;
    return _ts_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                params = {
                    clientId: config.clientId,
                    redirectURI: config.redirectURI,
                    scope: config.scope,
                    usePopup: config.usePopup,
                    responseType: config.responseType
                };
                return [
                    4,
                    loadAppleSdk(params, config.culture)
                ];
            case 1:
                appleId = _state.sent();
                return [
                    2,
                    !!appleId
                ];
        }
    });
});

export { AppleSdkLoader, AppleSdkLogin };
